// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #2c3e50;
  --secondary-color: #4a6eaf;
}

.light-theme {
  --primary-color: #f9f9f9;
  --text-color: #2c3e50;
}

.dark-theme {
  --primary-color: #2c3e50; /* Dark Background */
  --text-color: #f9f9f9; /* Light Text */
}

* {
  font-family: 'Inter';
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  display: flex;
  flex-direction: column;
  background-color: var(--text-color);
  color: var(--primary-color);
  transition: background-color 0.3s ease, color 0.3s ease;
}

#projectSubmitBtn,
button[type='submit'] {
  background-color: var(--text-color);
  color: var(--primary-color);
}

button[type='submit']:hover {
  color: var(--text-color);
}

h3 {
  margin-left: 1rem;
}

input,
textarea,
select,
button {
  border: 1px solid black;
  font: inherit;
  padding: 5px;
}

input {
  border: 2px solid #ccc; /* Light border */
  border-radius: 8px; /* Rounded corners */
  font-size: 16px;
}

button {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: var(--text-color);
  background-color: var(--primary-color); /* Primary blue */
  border: none;
  border-radius: 8px; /* Rounded corners */
  cursor: pointer;
  transition: all 0.3s ease; /* Smooth transitions */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
}

/* Hover effect */
button:hover {
  background-color: var(--primary-color); /* Darker blue on hover */
  transform: translateY(-2px); /* Subtle lift */
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15); /* Stronger shadow */
}

/* Active effect */
button:active {
  transform: translateY(0); /* Reset lift */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Reset shadow */
  background-color: var(--primary-color); /* Even darker blue */
}

button:disabled {
  background-color: #c0c0c0; /* Gray for disabled buttons */
  color: #6c757d; /* Muted text */
  cursor: not-allowed;
  box-shadow: none; /* Remove shadow */
}

input[required]:invalid {
  border-color: red;
}

input[required]:valid {
  border-color: green;
}

.container {
  display: flex;
  flex-grow: 1;
  background-color: var(--text-color);
}

.buttons-container,
.website-buttons-container {
  display: flex;
  flex-direction: row;
  margin-left: auto;
}

.website-buttons-container {
  margin-top: auto;
  margin-bottom: 1rem;
  margin-right: 1rem;
  gap: 10px;
}

.buttons-container {
  background-color: rgba(255, 255, 255, 0.5);
  width: fit-content;
  padding: 2px;
  border-radius: 4px;
}

#close-button,
.delete-button,
.edit-button,
.clear-storage-button,
.dark-light-theme-button {
  display: flex;
  height: 25px;
  width: auto;
  cursor: pointer;
}

.edit-button {
  height: 25px;
  width: 25px;
}

#close-button,
.edit-button {
  margin-left: auto;
}

select {
  padding: 10px 20px; /* Padding inside the dropdown */
  background-color: #fff; /* White background for the select */
  border: 2px solid #ccc; /* Light border */
  border-radius: 8px; /* Rounded corners */
  font-size: 16px; /* Slightly larger font size */
  appearance: auto; /* Use default dropdown arrow */
  outline: none; /* Remove focus outline */
  cursor: pointer; /* Pointer cursor on hover */
  transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition effects */
}

/* Hover effect on the select dropdown */
select:hover {
  border-color: #0066cc; /* Change border color on hover */
}

/* Focus effect on the select dropdown */
select:focus {
  border-color: #0066cc; /* Highlight the border when focused */
  box-shadow: 0 0 5px rgba(0, 102, 204, 0.3); /* Add subtle glow */
}

/* Styling the options inside the select */
select option {
  padding: 10px; /* Padding inside each option */
  font-size: 16px; /* Same font size as the select for consistency */
  border: none; /* Remove borders around options */
}

/* Hover effect for options */
select option:hover {
  background-color: var(--primary-color); /* Light background on hover */
}

.delete-button,
.edit-button,
.clear-storage-button,
.dark-light-theme-button {
  background-color: transparent; /* Transparent background */
  border: none; /* No border */
  cursor: pointer; /* Pointer cursor on hover */
  transition: transform 0.3s ease, fill 0.3s ease; /* Smooth hover effect */
}

/* Hover effect */
.delete-button:hover,
.delete-project-button:hover,
.edit-button:hover,
.clear-storage-button:hover,
.dark-light-theme-button:hover {
  transform: scale(1.2); /* Slightly scale up the icon */
  fill: #ff4d4d; /* Change color to red on hover */
}

.edit-button:hover {
  transform: scale(1.1);
}

/* Active state (when button is clicked) */
.delete-button:active,
.delete-project-button:active,
.edit-button:active,
.clear-storage-button:active,
.dark-light-theme-button:active {
  transform: scale(0.95); /* Scale down the icon to give a click effect */
  fill: #d43f3a; /* Darker red color when clicked */
}

.delete-button path {
  transition: fill 0.3s ease;
}

#projectTitle {
  font-weight: bold;
}

#sidebar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 15vw;
  height: 100%;
  background-color: var(--secondary-color);
}

#content {
  display: flex;
  flex-direction: column;
  width: 85vw;
  height: 100%;
}

.taskItem {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 150px;
}

#tasksContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, auto);
  gap: 10px;
  padding: 10px;
}

.sidebar-item {
  margin-left: 1rem;
  margin-top: 1rem;
}

.project-container {
  position: relative;
  display: flex;
  align-items: center;
  margin: 5px 0;
  width: 100%;
}

.delete-project-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 10px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.delete-project-button:hover {
  opacity: 1;
}

#form,
#projectForm,
#confirmation-form {
  display: none;
  position: fixed;
  gap: 7px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: var(--primary-color);
  color: var(--text-color);
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

#popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: none;
  z-index: 999;
  transition: opacity 0.3s ease;
}

#projectsSidebarContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-color);
  color: var(--text-color);
  font-weight: bold;
  padding: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB,EAAE,oBAAoB;EAC9C,qBAAqB,EAAE,eAAe;AACxC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;;EAEE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,sCAAsC,EAAE,iBAAiB;EACzD,YAAY;EACZ,kBAAkB,EAAE,oBAAoB;EACxC,eAAe;EACf,yBAAyB,EAAE,uBAAuB;EAClD,wCAAwC,EAAE,kBAAkB;AAC9D;;AAEA,iBAAiB;AACjB;EACE,sCAAsC,EAAE,yBAAyB;EACjE,2BAA2B,EAAE,gBAAgB;EAC7C,0CAA0C,EAAE,oBAAoB;AAClE;;AAEA,kBAAkB;AAClB;EACE,wBAAwB,EAAE,eAAe;EACzC,wCAAwC,EAAE,iBAAiB;EAC3D,sCAAsC,EAAE,qBAAqB;AAC/D;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,eAAe;EAC/B,mBAAmB;EACnB,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;EAKE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,EAAE,gCAAgC;EACpD,sBAAsB,EAAE,oCAAoC;EAC5D,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,8BAA8B;EAC/C,gBAAgB,EAAE,+BAA+B;EACjD,aAAa,EAAE,yBAAyB;EACxC,eAAe,EAAE,4BAA4B;EAC7C,wDAAwD,EAAE,8BAA8B;AAC1F;;AAEA,wCAAwC;AACxC;EACE,qBAAqB,EAAE,iCAAiC;AAC1D;;AAEA,wCAAwC;AACxC;EACE,qBAAqB,EAAE,sCAAsC;EAC7D,0CAA0C,EAAE,oBAAoB;AAClE;;AAEA,0CAA0C;AAC1C;EACE,aAAa,EAAE,+BAA+B;EAC9C,eAAe,EAAE,iDAAiD;EAClE,YAAY,EAAE,kCAAkC;AAClD;;AAEA,6BAA6B;AAC7B;EACE,sCAAsC,EAAE,8BAA8B;AACxE;;AAEA;;;;EAIE,6BAA6B,EAAE,2BAA2B;EAC1D,YAAY,EAAE,cAAc;EAC5B,eAAe,EAAE,4BAA4B;EAC7C,+CAA+C,EAAE,wBAAwB;AAC3E;;AAEA,iBAAiB;AACjB;;;;;EAKE,qBAAqB,EAAE,+BAA+B;EACtD,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;;;;;EAKE,sBAAsB,EAAE,+CAA+C;EACvE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[":root {\n  --primary-color: #2c3e50;\n  --secondary-color: #4a6eaf;\n}\n\n.light-theme {\n  --primary-color: #f9f9f9;\n  --text-color: #2c3e50;\n}\n\n.dark-theme {\n  --primary-color: #2c3e50; /* Dark Background */\n  --text-color: #f9f9f9; /* Light Text */\n}\n\n* {\n  font-family: 'Inter';\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--text-color);\n  color: var(--primary-color);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n#projectSubmitBtn,\nbutton[type='submit'] {\n  background-color: var(--text-color);\n  color: var(--primary-color);\n}\n\nbutton[type='submit']:hover {\n  color: var(--text-color);\n}\n\nh3 {\n  margin-left: 1rem;\n}\n\ninput,\ntextarea,\nselect,\nbutton {\n  border: 1px solid black;\n  font: inherit;\n  padding: 5px;\n}\n\ninput {\n  border: 2px solid #ccc; /* Light border */\n  border-radius: 8px; /* Rounded corners */\n  font-size: 16px;\n}\n\nbutton {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--text-color);\n  background-color: var(--primary-color); /* Primary blue */\n  border: none;\n  border-radius: 8px; /* Rounded corners */\n  cursor: pointer;\n  transition: all 0.3s ease; /* Smooth transitions */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n}\n\n/* Hover effect */\nbutton:hover {\n  background-color: var(--primary-color); /* Darker blue on hover */\n  transform: translateY(-2px); /* Subtle lift */\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15); /* Stronger shadow */\n}\n\n/* Active effect */\nbutton:active {\n  transform: translateY(0); /* Reset lift */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Reset shadow */\n  background-color: var(--primary-color); /* Even darker blue */\n}\n\nbutton:disabled {\n  background-color: #c0c0c0; /* Gray for disabled buttons */\n  color: #6c757d; /* Muted text */\n  cursor: not-allowed;\n  box-shadow: none; /* Remove shadow */\n}\n\ninput[required]:invalid {\n  border-color: red;\n}\n\ninput[required]:valid {\n  border-color: green;\n}\n\n.container {\n  display: flex;\n  flex-grow: 1;\n  background-color: var(--text-color);\n}\n\n.buttons-container,\n.website-buttons-container {\n  display: flex;\n  flex-direction: row;\n  margin-left: auto;\n}\n\n.website-buttons-container {\n  margin-top: auto;\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n  gap: 10px;\n}\n\n.buttons-container {\n  background-color: rgba(255, 255, 255, 0.5);\n  width: fit-content;\n  padding: 2px;\n  border-radius: 4px;\n}\n\n#close-button,\n.delete-button,\n.edit-button,\n.clear-storage-button,\n.dark-light-theme-button {\n  display: flex;\n  height: 25px;\n  width: auto;\n  cursor: pointer;\n}\n\n.edit-button {\n  height: 25px;\n  width: 25px;\n}\n\n#close-button,\n.edit-button {\n  margin-left: auto;\n}\n\nselect {\n  padding: 10px 20px; /* Padding inside the dropdown */\n  background-color: #fff; /* White background for the select */\n  border: 2px solid #ccc; /* Light border */\n  border-radius: 8px; /* Rounded corners */\n  font-size: 16px; /* Slightly larger font size */\n  appearance: auto; /* Use default dropdown arrow */\n  outline: none; /* Remove focus outline */\n  cursor: pointer; /* Pointer cursor on hover */\n  transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition effects */\n}\n\n/* Hover effect on the select dropdown */\nselect:hover {\n  border-color: #0066cc; /* Change border color on hover */\n}\n\n/* Focus effect on the select dropdown */\nselect:focus {\n  border-color: #0066cc; /* Highlight the border when focused */\n  box-shadow: 0 0 5px rgba(0, 102, 204, 0.3); /* Add subtle glow */\n}\n\n/* Styling the options inside the select */\nselect option {\n  padding: 10px; /* Padding inside each option */\n  font-size: 16px; /* Same font size as the select for consistency */\n  border: none; /* Remove borders around options */\n}\n\n/* Hover effect for options */\nselect option:hover {\n  background-color: var(--primary-color); /* Light background on hover */\n}\n\n.delete-button,\n.edit-button,\n.clear-storage-button,\n.dark-light-theme-button {\n  background-color: transparent; /* Transparent background */\n  border: none; /* No border */\n  cursor: pointer; /* Pointer cursor on hover */\n  transition: transform 0.3s ease, fill 0.3s ease; /* Smooth hover effect */\n}\n\n/* Hover effect */\n.delete-button:hover,\n.delete-project-button:hover,\n.edit-button:hover,\n.clear-storage-button:hover,\n.dark-light-theme-button:hover {\n  transform: scale(1.2); /* Slightly scale up the icon */\n  fill: #ff4d4d; /* Change color to red on hover */\n}\n\n.edit-button:hover {\n  transform: scale(1.1);\n}\n\n/* Active state (when button is clicked) */\n.delete-button:active,\n.delete-project-button:active,\n.edit-button:active,\n.clear-storage-button:active,\n.dark-light-theme-button:active {\n  transform: scale(0.95); /* Scale down the icon to give a click effect */\n  fill: #d43f3a; /* Darker red color when clicked */\n}\n\n.delete-button path {\n  transition: fill 0.3s ease;\n}\n\n#projectTitle {\n  font-weight: bold;\n}\n\n#sidebar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 15vw;\n  height: 100%;\n  background-color: var(--secondary-color);\n}\n\n#content {\n  display: flex;\n  flex-direction: column;\n  width: 85vw;\n  height: 100%;\n}\n\n.taskItem {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  margin: 10px 0;\n  background-color: #f9f9f9;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  min-height: 150px;\n}\n\n#tasksContainer {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(4, auto);\n  gap: 10px;\n  padding: 10px;\n}\n\n.sidebar-item {\n  margin-left: 1rem;\n  margin-top: 1rem;\n}\n\n.project-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 5px 0;\n  width: 100%;\n}\n\n.delete-project-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-left: 10px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.delete-project-button:hover {\n  opacity: 1;\n}\n\n#form,\n#projectForm,\n#confirmation-form {\n  display: none;\n  position: fixed;\n  gap: 7px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 20px;\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n#popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  display: none;\n  z-index: 999;\n  transition: opacity 0.3s ease;\n}\n\n#projectsSidebarContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\nfooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  font-weight: bold;\n  padding: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
